import { shape, string, number, oneOfType } from 'prop-types';

export default shape({
  name: string,
  obisCode: string.isRequired,
  attributeId: number.isRequired,
  value: oneOfType([number, string]),
  valueRaw: oneOfType([number, string]),
});
